// Auto-generated from the bedd.dev business.html snapshot.
// Internal hrefs rewritten to SPA paths via `.scratch/port-page.py`; nav +
// footer are composed from `marketing-shared/` so all marketing pages stay
// in lock-step. To re-port, drop a fresh snapshot at
// `.scratch/bedd-snapshot/business.html` and re-run the build script.

import { navMarkup } from '../marketing-shared/nav';
import { footerMarkup } from '../marketing-shared/footer';

export const markup = `${navMarkup('business')}

<!-- ──────────────────────────────────────────────
     HERO — For Business
─────────────────────────────────────────────── -->
<section class="hero">
  <div class="container">
    <div class="hero-grid">
      <div class="hero-copy">
        <div class="eyebrow hero-eyebrow-anim">For Business · Team & Hiring</div>
        <h1>
          <span class="word">Know</span>
          <span class="word">your</span>
          <span class="word accent">team.</span>
          <span class="word">Hire with</span>
          <span class="word accent">confidence.</span>
        </h1>
        <p class="lede">
          Spot Revit skill gaps before they become project risk. Screen candidates by verified competency, not CV claims.
          <strong>Build teams that deliver from day one.</strong>
        </p>
        <div class="hero-actions">
          <a href="#contact" class="btn btn-primary btn-magnetic">Book a team demo →</a>
          <a href="#pricing" class="btn btn-ghost">See team pricing</a>
        </div>
        <div class="hero-trust">Trusted by 142 BIM teams worldwide</div>
      </div>

      <div class="hero-mockup">
        <div class="mockup-card mockup-main">
          <div class="mockup-header">
            <div class="mockup-title-block">
              <div class="label">Team Dashboard</div>
              <div class="title">Architecture Team · 12</div>
            </div>
            <div class="mockup-status">Q2 Review</div>
          </div>

          <div class="skill-row">
            <div class="skill-name">Modeling</div>
            <div class="skill-bar"><div class="skill-fill" style="--w: 86%"></div></div>
            <div class="skill-score">86</div>
          </div>
          <div class="skill-row">
            <div class="skill-name">Families</div>
            <div class="skill-bar"><div class="skill-fill acc" style="--w: 62%"></div></div>
            <div class="skill-score">62</div>
          </div>
          <div class="skill-row">
            <div class="skill-name">Documentation</div>
            <div class="skill-bar"><div class="skill-fill" style="--w: 79%"></div></div>
            <div class="skill-score">79</div>
          </div>
          <div class="skill-row">
            <div class="skill-name">Coordination</div>
            <div class="skill-bar"><div class="skill-fill acc" style="--w: 54%"></div></div>
            <div class="skill-score">54</div>
          </div>
          <div class="skill-row">
            <div class="skill-name">Worksharing</div>
            <div class="skill-bar"><div class="skill-fill" style="--w: 81%"></div></div>
            <div class="skill-score">81</div>
          </div>

          <div class="mockup-footer">
            <span><span class="dot"></span>2 gaps identified · plan ready</span>
            <span>Team avg 72</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     COMPARISON BLOCK — Hiring lens
─────────────────────────────────────────────── -->
<section class="section">
  <div class="container">
    <span class="section-anchor">02 / The difference</span>
    <div class="section-head reveal">
      <div class="lhs">
        <div class="label">The hiring problem</div>
        <h2>CVs and interviews<br>don't distinguish<br><span class="accent">real talent from AI.</span></h2>
      </div>
      <div class="rhs">
        Proven skills require industry-focused benchmarking. By testing and certifying, we help you uncover skill gaps and hire with confidence.
      </div>
    </div>

    <div class="compare-grid reveal-stagger">
      <div class="compare-col">
        <div class="col-tag">A candidate's CV</div>
        <h3>Says everything.<br>Proves nothing.</h3>
        <ul class="compare-list">
          <li><span class="icon no">—</span>Self-reported "expert" levels</li>
          <li><span class="icon no">—</span>Inflated software fluency</li>
          <li><span class="icon no">—</span>Team output as personal work</li>
          <li><span class="icon no">—</span>Polished by AI tools</li>
        </ul>
      </div>

      <div class="compare-col">
        <div class="col-tag">A first interview</div>
        <h3>Hard to standardise.<br>Easier to fake.</h3>
        <ul class="compare-list">
          <li><span class="icon no">—</span>Different questions, different bar</li>
          <li><span class="icon no">—</span>Theory talk, no live Revit</li>
          <li><span class="icon no">—</span>Hours of senior time spent</li>
          <li><span class="icon no">—</span>Gut feel over evidence</li>
        </ul>
      </div>

      <div class="compare-col featured">
        <div class="col-tag">BIMAssess</div>
        <h3>Same bar.<br>Verified result.</h3>
        <ul class="compare-list">
          <li><span class="icon yes"><svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M2 4.5l1.6 1.6 3.4-3.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>One score, every candidate</li>
          <li><span class="icon yes"><svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M2 4.5l1.6 1.6 3.4-3.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>Real Revit tasks, not theory</li>
          <li><span class="icon yes"><svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M2 4.5l1.6 1.6 3.4-3.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>Shortlist in minutes, not days</li>
          <li><span class="icon yes"><svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M2 4.5l1.6 1.6 3.4-3.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>Industry-aligned, verifiable</li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     OUTCOMES — Three business value props
─────────────────────────────────────────────── -->
<section class="section section-warm">
  <div class="container">
    <span class="section-anchor">03 / Outcomes</span>
    <div class="section-head reveal">
      <div class="lhs">
        <div class="label">What you get</div>
        <h2>Three outcomes.<br><span class="accent">Real impact.</span></h2>
      </div>
      <div class="rhs">
        Whether you're recruiting, training, or planning project resourcing—BIMAssess turns Revit competency into something you can actually measure.
      </div>
    </div>

    <div class="why-grid reveal-stagger">
      <div class="why-card">
        <div class="why-visual">
          <div class="vis-practitioner">
            <div class="check-stack">
              <div class="check-row">
                <svg viewBox="0 0 12 12" fill="none"><path d="M3 6l2 2 4-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
                Candidate A · 87
              </div>
              <div class="check-row">
                <svg viewBox="0 0 12 12" fill="none"><path d="M3 6l2 2 4-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
                Candidate B · 81
              </div>
              <div class="check-row muted">
                <svg viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="3" stroke="currentColor" stroke-width="1.4"/></svg>
                Candidate C · 54
              </div>
              <div class="check-row muted">
                <svg viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="3" stroke="currentColor" stroke-width="1.4"/></svg>
                Candidate D · 41
              </div>
            </div>
          </div>
        </div>
        <h3>Hire faster, hire right.</h3>
        <p>Screen candidates with a verified Revit score before the first interview. Shortlist in minutes. Stop wasting senior time on unqualified applicants.</p>
      </div>

      <div class="why-card">
        <div class="why-visual">
          <div class="vis-standards">
            <div class="std-card">
              <div class="lbl">Team</div>
              <div class="val">72</div>
            </div>
            <div class="std-card acc">
              <div class="lbl">Gap</div>
              <div class="val">Families</div>
            </div>
            <div class="std-card">
              <div class="lbl">Plan</div>
              <div class="val">Q3</div>
            </div>
          </div>
        </div>
        <h3>Train where it matters.</h3>
        <p>Pinpoint exactly which skills your team is weak on—not from instinct, but from data. Build a training plan that actually changes delivery quality.</p>
      </div>

      <div class="why-card">
        <div class="why-visual">
          <div class="vis-cert">
            <div class="cert-card">
              <div class="cert-head">
                <span>Team Cert</span>
                <span>VERIFIED</span>
              </div>
              <div class="cert-name">12 of 12 · BIM Champion</div>
              <div class="cert-score">avg 84 / 100</div>
            </div>
            <div class="cert-stamp">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M5 9l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
        <h3>Win bids with proof.</h3>
        <p>Show clients verified BIM credentials across your team. Stand out in tenders. Walk into bid meetings with evidence, not just CVs.</p>
      </div>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     HOW IT WORKS — Business
─────────────────────────────────────────────── -->
<section class="section">
  <div class="container">
    <span class="section-anchor">04 / How it works</span>
    <div class="section-head reveal">
      <div class="lhs">
        <div class="label">How it works</div>
        <h2>Three steps.<br><span class="accent">From sign-up to insight.</span></h2>
      </div>
      <div class="rhs">
        Whether you're assessing a 5-person team or a 500-person business, the workflow scales. Most teams have their first results in under a week.
      </div>
    </div>

    <div class="steps-grid reveal-stagger">
      <div class="step">
        <div class="step-num mono">01</div>
        <h3>Invite your team.</h3>
        <p>Add members or bulk-import via CSV. Choose which assessments each role needs—architecture, MEP, structural, interior—or let us recommend.</p>
      </div>
      <div class="step-arrow">
        <svg width="48" height="12" viewBox="0 0 48 12" fill="none">
          <path d="M0 6h44m0 0l-5-5m5 5l-5 5" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="step">
        <div class="step-num mono">02</div>
        <h3>They take the assessments.</h3>
        <p>Each person completes their assigned exams on their own schedule. Real Revit-task based scenarios. Auto-saved, anti-cheat measures, 60–90 minutes each.</p>
      </div>
      <div class="step-arrow">
        <svg width="48" height="12" viewBox="0 0 48 12" fill="none">
          <path d="M0 6h44m0 0l-5-5m5 5l-5 5" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="step">
        <div class="step-num mono">03</div>
        <h3>See the gaps.</h3>
        <p>Team dashboard surfaces individual scores, role-level competency, and the specific Revit skills where your team is weakest. Export to PDF for board, bid, or training.</p>
      </div>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     PRICING — Business
─────────────────────────────────────────────── -->
<section class="section section-warm" id="pricing">
  <div class="container">
    <span class="section-anchor">05 / Pricing</span>
    <div class="section-head reveal">
      <div class="lhs">
        <div class="label">Pricing for business</div>
        <h2>Scale with<br><span class="accent">your team.</span></h2>
      </div>
      <div class="rhs">
        From a small studio to enterprise—every plan includes the team dashboard, verifiable credentials, and bulk seats.
      </div>
    </div>

    <div class="price-grid reveal-stagger">
      <div class="price-card">
        <div class="price-tag">Team</div>
        <h3>Studio</h3>
        <div class="price-sub">For small BIM teams.</div>
        <div class="price-amount">
          <span class="num">$249</span>
          <span class="per">/ month</span>
        </div>
        <ul class="price-features">
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Up to 10 team members</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>All 18 assessments</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Team dashboard + skill gaps</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>PDF export for bids</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Email support</li>
        </ul>
        <a href="#" class="btn btn-ghost">Start free trial</a>
      </div>

      <div class="price-card featured">
        <div class="price-tag">Most popular</div>
        <h3>Business</h3>
        <div class="price-sub">For growing BIM teams and recruiters.</div>
        <div class="price-amount">
          <span class="num">$899</span>
          <span class="per">/ month</span>
        </div>
        <ul class="price-features">
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Up to 50 team members</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Candidate screening portal</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Role-based assessment templates</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>API + ATS integration</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Priority support + onboarding</li>
        </ul>
        <a href="#" class="btn btn-primary">Book a demo</a>
      </div>

      <div class="price-card">
        <div class="price-tag">Business</div>
        <h3>Custom</h3>
        <div class="price-sub">For large practices and agencies.</div>
        <div class="price-amount">
          <span class="num">Talk to us</span>
        </div>
        <ul class="price-features">
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Unlimited team members</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Custom assessments</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>SSO + advanced compliance</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>White-label option</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Dedicated success manager</li>
        </ul>
        <a href="#" class="btn btn-ghost">Contact sales</a>
      </div>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     TESTIMONIALS — Business
─────────────────────────────────────────────── -->
<section class="section">
  <div class="container">
    <span class="section-anchor">06 / Customers</span>
    <div class="section-head reveal">
      <div class="lhs">
        <div class="label">Customers</div>
        <h2>Trusted by the<br><span class="accent">teams that hire.</span></h2>
      </div>
      <div class="rhs">
        From boutique studios to multinational practices—real teams using BIMAssess to scale Revit capability.
      </div>
    </div>

    <div class="testimonial-grid reveal-stagger">
      <div class="testimonial">
        <div class="testimonial-quote">
          "We rolled it out across our 40-person Revit team. In six weeks we identified three critical skill gaps we didn't know existed—and trained around them."
        </div>
        <div class="testimonial-attr">
          <div class="testimonial-avatar">M</div>
          <div class="testimonial-meta">
            <div class="name">Marcus K.</div>
            <div class="role">BIM Manager · Singapore</div>
          </div>
        </div>
      </div>

      <div class="testimonial">
        <div class="testimonial-quote">
          "I shortlist BIM candidates faster now. A verified BIMAssess score tells me more in 30 seconds than a 3-page CV ever did."
        </div>
        <div class="testimonial-attr">
          <div class="testimonial-avatar">S</div>
          <div class="testimonial-meta">
            <div class="name">Sara L.</div>
            <div class="role">Technical Recruiter · Berlin</div>
          </div>
        </div>
      </div>

      <div class="testimonial">
        <div class="testimonial-quote">
          "Our last bid won on capability evidence. Verified team scores changed how the client saw us—suddenly we weren't claiming, we were proving."
        </div>
        <div class="testimonial-attr">
          <div class="testimonial-avatar">R</div>
          <div class="testimonial-meta">
            <div class="name">Renata P.</div>
            <div class="role">Practice Director · Sydney</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     FAQ — Business
─────────────────────────────────────────────── -->
<section class="section section-warm">
  <div class="container">
    <span class="section-anchor">07 / FAQ</span>
    <div class="section-head reveal">
      <div class="lhs">
        <div class="label">FAQ</div>
        <h2>Common questions<br>from <span class="accent">teams.</span></h2>
      </div>
      <div class="rhs">
        Want a deeper walkthrough? <a href="#contact" style="color:var(--ink);font-weight:500;">Book a demo →</a>
      </div>
    </div>

    <div class="faq-wrap reveal">
      <details class="faq-item" open>
        <summary>How quickly can we get our team set up?</summary>
        <p>Most teams are running their first round of assessments within 48 hours. Bulk CSV import, role-based assessment templates, and one-click invitations mean even 50-person rollouts take less than a morning of admin.</p>
      </details>
      <details class="faq-item">
        <summary>Can we use BIMAssess as part of our hiring process?</summary>
        <p>Yes—the Business plan includes a candidate screening portal. Send a link to applicants, they take a chosen assessment, you see scores ranked side-by-side. ATS integration is available on Business and Business plans.</p>
      </details>
      <details class="faq-item">
        <summary>What stops candidates from cheating?</summary>
        <p>Every Revit-task scenario is randomised from a question bank. We log activity patterns, browser focus, and time-per-task to flag anomalies. For high-stakes hiring, we offer proctored assessments at no extra cost on Business plans.</p>
      </details>
      <details class="faq-item">
        <summary>Can we create our own custom assessments?</summary>
        <p>Yes, on Business plans. Our BIM experts work with your team to build assessments around your office templates, your families library, or your specific project type. Typically takes 2–4 weeks.</p>
      </details>
      <details class="faq-item">
        <summary>How do you handle data privacy?</summary>
        <p>SOC 2 compliant. GDPR ready. Individual scores are only visible to designated team admins—never to colleagues. Candidate data is automatically deleted 90 days after the assessment unless retained for hiring records.</p>
      </details>
      <details class="faq-item">
        <summary>Is there a free trial?</summary>
        <p>Yes—14-day free trial on Studio and Business plans. Full team access, no card required, cancel anytime. Business plans start with a paid pilot tailored to your scope.</p>
      </details>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     FINAL CTA — Business
─────────────────────────────────────────────── -->
<section class="final-cta" id="contact">
  <div class="container">
    <h2>Stop guessing.<br>Start <span style="color:#0139B7">measuring.</span></h2>
    <p>Book a 20-minute demo. We'll walk through the dashboard, the screening flow, and tailor a pilot to your team.</p>
    <div style="display:flex; gap:12px; justify-content:center; flex-wrap:wrap;">
      <a href="#" class="btn btn-primary btn-magnetic">Book a team demo →</a>
      <a href="/individual" data-spa-link class="btn btn-ghost">For Individual →</a>
    </div>
  </div>
</section>

${footerMarkup()}`;
